<template>
    <section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card" v-if="user">
                        <div class="card-header">
                            Scheda utente
                        </div>
                        <div class="card-body py-5">
                            <div class="row">
                                <div class="col-md-6 text-center">
                                    <div class="uploader-wrapper">
                                        <template v-if="user.image">
                                            <img class="user-thumb w-50 mt-2" :src="user.image" alt="" />
                                        </template>
                                        <template v-else>
                                            <img class="user-thumb w-50 mt-2"
                                                :src="require(`@/assets/images/default.png`)" alt="" />
                                        </template>
                                        <input type="file" ref="file" name="file" @change="handleFileUpload()" />
                                        <font-awesome-icon icon="cloud-upload-alt"></font-awesome-icon>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <!-- <div class="form-group">
                                                <label>Nome utente *</label>
                                                <input :readonly="currentUser.id === user.id" type="text" name="username"
                                                    v-model="user.username" class="form-control" required />
                                            </div> -->
                                            <div class="form-group">
                                                <label for="InputUsername">Matricola *</label>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <strong class="input-group-text">IT</strong>
                                                    </div>
                                                    <input :readonly='currentUser.type !== 1' maxlength="6" id="InputUsername" type="text" v-model="fakeUsername" class="form-control" placeholder="Numero matricola">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group" v-if="currentUser.type === 1">
                                                <label>Tipologia *</label>
                                                <select class="form-control" v-model="user.type" required :disabled="currentUser.id === user.id">
                                                    <option :value="null" disabled>-- Seleziona tipologia di utente --</option>
                                                    <option value="1">Admin</option>
                                                    <option value="2">Utente</option>
                                                    <option value="3">Gruppo di utenti</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="form-group">
                                                <label>Email *</label>
                                                <input :readonly='currentUser.type !== 1' type="email" name="email" v-model="user.email" class="form-control" required />
                                            </div>
                                            <!-- <div class="form-group" v-if="user.type === 2 && currentUser.type === 1 && groupsUsers.length">
                                                <label>Gruppo (facoltativo)</label>
                                                <select class="form-control" v-model="user.parent">
                                                    <option :value="null" disabled>-- Seleziona il gruppo --</option>
                                                    <option v-for="group in groupsUsers" :key="group.id" :value="group.id">
                                                        {{ group.username }}
                                                    </option>
                                                </select>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Client Errors -->
                            <div v-if="$v.$error" class="alert alert-danger mb-0">
                                <span v-if="!$v.user.required || !$v.user.email">Un indirizzo email valido è richiesta.<br></span>
                                <span v-if="!$v.fakeUsername">Il campo <i>Matricola</i> è richiesto.<br></span>
                                <span v-if="!$v.fakeUsername">Il campo <i>Matricola</i> dev'essere lungo 6 caratteri.<br></span>
                                <span v-if="!$v.fakeUsername">Il campo <i>Matricola</i> dev'essere lungo 6 caratteri.<br></span>
                                <span v-if="!$v.fakeUsername">Il campo <i>Matricola</i> dev'essere un numero.<br></span>
                            </div>
                            <!-- Server Errors -->
                            <div class="alert alert-danger" v-if="hasRegistrationErrors">
                                <span class="d-block" v-for="(error, i) in registrationErrors" :key="i">
                                    <b>{{ i.replace('username', 'matricola') }}</b> <span v-for="(e, ie) in error" :key="ie">{{ e }}<br/></span>
                                </span>
                            </div>
                        </div>
                        <div class="card-footer d-flex bd-highlight">
                            <button type="button" class="btn btn-primary" @click="$router.go(-1)">
                                <font-awesome-icon icon="angle-left"></font-awesome-icon>&nbsp;INDIETRO
                            </button>
                            <button type="submit" class="btn btn-success ml-auto bd-highlight" @click="saveuser">
                                <font-awesome-icon :icon="['far','save']"></font-awesome-icon>&nbsp;SALVA
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {
    UsersService
} from '@/common/api.service.js'
import {
    API_URL
} from '@/common/config'
import {
    email,
    maxLength,
    minLength,
    numeric,
    required
} from 'vuelidate/lib/validators'
import {
    mapGetters,
    mapState
} from 'vuex'
import {
    // GET_LIST,
    // CREATE,
    UPDATE,
    GET_SINGLE
} from '@/store/actions.type'
import {
    MODULE_NAME as USERS_MODULE_NAME
} from '@/store/modules/users.module'

export default {
    name: 'user-detail',
    data () {
        return {
            file: '',
            fakeUsername: ''
        }
    },
    validations: {
        fakeUsername: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(6),
            numeric
        },
        user: {
            email: {
                required,
                email
            },
            type: {
                required
            }
        }
    },
    mounted () {
        this.$v.$reset()
        this.fetchUser()
    },
    computed: {
        uploadAPI () {
            return `${API_URL}/users/${this.user.id}/picture`
        },
        // groupsUsers () {
        //     var _groups = []
        //     _groups = this.allUsers.filter((u) => {
        //         return u.type === 3
        //     })
        //     return _groups
        // },
        ...mapState({
            registrationErrors: state => state.USERS.errors
        }),
        ...mapGetters([
            'currentUser'
        ]),
        ...mapGetters({
            // users: `${USERS_MODULE_NAME}/getList`,
            user: `${USERS_MODULE_NAME}/getSingle`,
        }),
        // allUsers () {
        //     return this.users.data || []
        // },
        hasRegistrationErrors () {
            return Object.keys(this.registrationErrors).length !== 0 && this.registrationErrors.constructor === Object
        }
    },
    // watch: {
    //     users: {
    //         handler (newVal) {
    //             if (!newVal.data) this.fetchUsers()
    //         },
    //         immediate: true
    //     }
    // },
    methods: {
        submitFile () {
            let userId = this.user.id
            let formData = new FormData()
            formData.append('file', this.file)
            UsersService.picture(userId, formData)
                .then((
                    result
                ) => {
                    if (result.status === 200) {
                        this.fetchUser()
                    }
                }).catch(() => {
                    this.$swal('Oooops!', 'Si è verificato un problema', 'error')
                })
        },
        handleFileUpload () {
            this.file = this.$refs.file.files[0]
            this.submitFile()
        },
        // fetchUsers () {
        //     this.$store.dispatch(`${USERS_MODULE_NAME}/${GET_LIST}`, {
        //         query: {}
        //     })
        // },
        fetchUser () {
            this.$store.dispatch(`${USERS_MODULE_NAME}/${GET_SINGLE}`, {
                id: this.$route.params.id
            }).then(() => {
                this.fakeUsername = this.user.username.replace('IT', '')
            })
        },
        saveuser () {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.user.created_by = this.currentUser.id
                this.user.username = `IT${this.fakeUsername}`

                this.$store.dispatch(`${USERS_MODULE_NAME}/${UPDATE}`, this.user).then((data) => {
                    if (data.status === 200) {
                        this.$swal('Ben fatto!', '', 'success')
                        // Ricarico il profilo (non è necessario)
                        this.fetchUser()
                    }
                }).catch(() => {
                    this.$swal('Oooops!', 'Si è verificato un problema', 'error')
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.uploader-wrapper {
    position: relative;
    img {
        display: block;
        margin: auto;
        transition: opacity .3s;
    }
    input {
        cursor: pointer;
        display: block;
        height: 100%;
        left: 0;
        opacity: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 999;
    }
    svg {
        display: block;
        height: 40px;
        left: calc( 50% - 20px );
        opacity: 0;
        position: absolute;
        transition: opacity .3s;
        top: calc( 50% - 20px );
        width: 40px;
        z-index: 99;
    }
    &:hover {
        img {
            opacity: .5;
        }
        svg {
            opacity: 1;
        }
    }
}
</style>
